module.exports = {"610324001":"城关街道","610324101":"天度镇","610324102":"午井镇","610324103":"绛帐镇","610324104":"段家镇","610324105":"杏林镇","610324106":"召公镇","610324107":"法门镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610324.json
// module id = 2591
// module chunks = 0